(function(){
  var root=document.querySelector('[data-ats-extras]'); if(!root) return;
  root.querySelectorAll('[data-ats-tab]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var name=btn.getAttribute('data-ats-tab');
      root.querySelectorAll('[data-ats-tab]').forEach(function(b){b.classList.toggle('is-active',b===btn);});
      root.querySelectorAll('[data-ats-panel]').forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-ats-panel')===name);});
    });
  });
  function openTab(n){var b=root.querySelector('[data-ats-tab="'+n+'"]');if(b)b.click()}
  if(location.hash==='#fabric')openTab('fabric');
  if(location.hash==='#delivery')openTab('delivery');
  var panel=root.querySelector('[data-ats-panel="description"]');
  if(panel){
    var cands=[].slice.call(document.querySelectorAll('.rte')).filter(function(el){
      if(root.contains(el)) return false;
      if(el.closest('product-price')) return false;
      return (el.textContent||'').trim().length>80;
    });
    cands.sort(function(a,b){return b.textContent.trim().length-a.textContent.trim().length});
    if(cands[0]) panel.insertBefore(cands[0], panel.firstChild);
  }
  root.querySelectorAll('[data-ats-open]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var d=root.querySelector('[data-ats-modal="'+btn.getAttribute('data-ats-open')+'"]');
      if(d){d.showModal();var f=d.querySelector('input,textarea,button');if(f)f.focus()}
    });
  });
  root.querySelectorAll('[data-ats-close]').forEach(function(b){b.addEventListener('click',function(){b.closest('dialog').close()})});
  root.querySelectorAll('dialog').forEach(function(d){d.addEventListener('click',function(e){if(e.target===d)d.close()})});
  var form=root.querySelector('[data-ats-ask]');
  if(form){form.addEventListener('submit',function(e){
    e.preventDefault();
    var st=form.querySelector('[data-ats-status]');st.className='ats-ask__status';
    fetch('/contact',{method:'POST',body:new FormData(form),headers:{'Accept':'text/html'}}).then(function(r){
      if(r.ok){st.textContent='Thanks - we will reply by email shortly.';form.reset();}
      else{st.textContent='Something went wrong. Please email us directly.';st.classList.add('is-error');}
    }).catch(function(){st.textContent='Network error. Please try again.';st.classList.add('is-error');});
  })}
  var chartImg=root.querySelector('[data-ats-modal="size-chart"] img');
  var grid=document.querySelector('.media-gallery__grid');
  if(chartImg&&grid&&!grid.querySelector('.ats-sizechart-slide')){
    var li=document.createElement('li');li.className='ats-sizechart-slide';
    var ci=document.createElement('img');ci.src=chartImg.getAttribute('src');ci.alt='Size Chart';ci.loading='lazy';
    li.appendChild(ci);grid.appendChild(li);
  }
  var ATS_MAGNIFY=false;
  var lens=null;
  function ensureLens(){if(!lens){lens=document.createElement('div');lens.className='ats-lens';document.body.appendChild(lens);}return lens;}
  function showLens(img,cx,cy){
    var l=ensureLens(),src=img.currentSrc||img.src; if(!src) return;
    var r=img.getBoundingClientRect();
    var size=Math.min(r.width,r.height)*0.55;
    l.style.backgroundImage='url("'+src+'")';
    l.style.width=size+'px';l.style.height=size+'px';l.style.display='block';
    var x=cx-r.left,y=cy-r.top,ratio=2.5;
    l.style.left=(cx+window.scrollX-size/2)+'px';
    l.style.top=(cy+window.scrollY-size/2)+'px';
    l.style.backgroundSize=(r.width*ratio)+'px '+(r.height*ratio)+'px';
    l.style.backgroundPosition=(-(x*ratio-size/2))+'px '+(-(y*ratio-size/2))+'px';
  }
  function hideLens(){if(lens)lens.style.display='none'}
  var touch=matchMedia('(hover: none)').matches;
  if(ATS_MAGNIFY) document.querySelectorAll('.product-media__image').forEach(function(img){
    var wrap=img.closest('.product-media-container')||img.parentElement;
    if(!wrap)return;
    img.addEventListener('contextmenu',function(e){e.preventDefault()});
    if(touch){
      var active=false;
      wrap.addEventListener('touchstart',function(e){
        var t=e.touches[0]; if(!t) return;
        if(!active){active=true;showLens(img,t.clientX,t.clientY);e.preventDefault();}
        else{active=false;hideLens();}
      },{passive:false});
      wrap.addEventListener('touchmove',function(e){
        if(!active) return;
        var t=e.touches[0]; if(!t) return;
        e.preventDefault(); showLens(img,t.clientX,t.clientY);
      },{passive:false});
      wrap.addEventListener('touchend',function(){ if(active){active=false;hideLens();} });
      return;
    }
    wrap.classList.add('ats-magnify');
    wrap.addEventListener('mouseenter',function(e){showLens(img,e.clientX,e.clientY)});
    wrap.addEventListener('mousemove',function(e){showLens(img,e.clientX,e.clientY)});
    wrap.addEventListener('mouseleave',hideLens);
  });
})();